export class AuthorizationBody implements Object {
  token: string;
}

export interface ITokenRequestData {
  loginKey?: string;
  securityCode?: string;
}

export class AuthorizationBodyRecruitmentTechnologies implements Object {
  token: string;
}

export class TFACodeVerificationRequestData {
  code: string;
  loginKey?: string;
  securityCode?: string;
}
